import { Paragraph } from '@zillow/constellation';
import { ClampedText } from '@zillow/zrs-rental-applications';
import { distanceInWords } from 'date-fns';
import React from 'react';
import { SectionNav } from '../../../../../components/SectionNav';
import { FULLSTORY_EXCLUDE } from '../../../../../constants/fullstory';

export default function InvitedCard({ invitationToApply }) {
  const { firstName, lastName, invitedDateTime, email } = invitationToApply;
  const name = [firstName, lastName].filter(Boolean).join(' ');
  const now = new Date();
  return (
    <SectionNav isClickable={false}>
      <Paragraph fontType="finePrintHeading" fontColor="textMedium" className={FULLSTORY_EXCLUDE}>
        {name}
      </Paragraph>
      <Paragraph fontType="body" fontColor="textDark">
        Invited {distanceInWords(now, invitedDateTime, { addSuffix: true })}
      </Paragraph>
      <ClampedText maxLines={1} fontColor="textMedium" fontType="bodySmall" as="p" className={FULLSTORY_EXCLUDE}>
        {email}
      </ClampedText>
    </SectionNav>
  );
}
